<template>
  <div>
    <div class="bg-pattern overlay-stReg logReg-container">
      <div class="st-wizard-col mx-auto">
        <!--sole trader wizard block start-->
        <div class="st-heading">Sole trader</div>
        <div class="st-wizard">
          <div class="st-card">
            <SoleTraderForm></SoleTraderForm>
          </div>
        </div>
        <!--ended sole trader wizard block-->
      </div>
    </div>
  </div>
</template>
<script>
import SoleTraderForm from './SoleTraderForm.vue';
export default {
  name: "SoleTraderCompany",

  components:{
    SoleTraderForm
  },
  data() {
    return {
      loadingInstance: null,
      loading: false,
    };
  },
  mounted() {

  },
  computed: {
    pageTitle() {
      return (document.title = `${this.title.replace(/\b\w/g, (match) =>
          match.toUpperCase()
      )} | Smoothbalance`);
    },
  },
 methods: {
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
        fullscreen: true
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
  },
};
</script>
<style scoped>
.st-wizard-col {
  width: 637px;
  max-width: 100%;
  position: relative;
  z-index: 1;
}

.st-wizard {
  width: 100%;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

/* Title above the popup */
.st-heading {
  background: #1c4e80;
  height: 55px;
  width: 210px;
  margin: 0;
  padding: 8px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px 8px 0 0;
}

/* Card body */
.st-card {
  background: #fbfbfc;
  padding: 34px 74px 40px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

@media (max-width: 520px) {
  .st-card {
    padding: 26px 20px 32px;
  }
}
</style>
